import { render, staticRenderFns } from "./AddBuyoutLinks.vue?vue&type=template&id=1f54775d&"
import script from "./AddBuyoutLinks.vue?vue&type=script&lang=ts&"
export * from "./AddBuyoutLinks.vue?vue&type=script&lang=ts&"
import style0 from "./AddBuyoutLinks.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports